export default "__VITE_ASSET__403c57b9__"